<template>
    <div
        class="md-nbr-local standard"
        :style="{ paddingTop, marginBottom }"
        v-if="
            !(
                (countryConfig === 'canada' &&
                    !isCommuteScoreHasData &&
                    !isTemperatureHasData) || isCensusSubdivision
            )
        "
    >
        <div class="local-box">
            <div class="local-content mg-container">
                <div class="commute">
                    <div class="title-wrap">
                        <h2 class="title">{{ $t('md-nbr-local.commuteScore') }}</h2>
                        <AttomDesc />
                    </div>
                    <div
                        class="commute-content"
                        :class="{ empty: !dataCommute.length }"
                    >
                        <div class="empty-text">
                            {{ $t('md-nbr-local.comingSoon') }}
                        </div>
                        <div
                            v-for="item in dataCommute"
                            :key="item.name"
                            class="item"
                            :class="{ highlight: item.value === maxCommute }"
                            :style="item.style"
                        >
                            <span class="value">{{ item.value }}</span>
                            <span class="iconfont" :class="item.icon"></span>
                            <span class="name">{{ item.name }}</span>
                        </div>
                    </div>
                </div>
                <nbr-chart
                    class="temperature-chart"
                    type="line"
                    subTitle="(°F)"
                    :options="temperatureOptions"
                    :title="$t('md-nbr-local.temperature')"
                    :showAttom="true"
                ></nbr-chart>
            </div>
            <div class="left-background"></div>
            <div class="right-background"></div>
        </div>
    </div>
</template>

<script>
import common from '../index';
import nbrChart from '../../../components/nbr-chart/standard.vue';
import { normal } from '../../defaultSpacing.js';
export default {
    mixins: [common],
    data: function() {
        return {
            ...normal
        };
    },
    methods: {
        setTemperatureOptions(data) {
            const baseOption = {
                grid: {
                    left: 20,
                    containLabel: false
                },
                tooltip: {
                    formatter: function(param) {
                        var str =
                            '<div style="margin:0 0 5px 0;font-family:var(--font-bold);color:white;">' +
                            param[0].name +
                            '</div><div style="line-height:1.67;">' +
                            param[0].data.toFixed(0) +
                            ' °F - ' +
                            param[1].data.toFixed(0) +
                            ' °F</div>';
                        return str;
                    },
                    axisPointer: {
                        lineStyle: {
                            width: 1,
                            color: '#9ee8c1'
                        }
                    }
                },
                xAxis: [
                    {
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#6dd07f'
                            }
                        },
                        axisLabel: {
                            color: '#a3edb1'
                        },
                        data: [
                            this.$t('md-nbr-local.jan'),
                            this.$t('md-nbr-local.apr'),
                            this.$t('md-nbr-local.jul'),
                            this.$t('md-nbr-local.oct')
                        ]
                    }
                ],
                yAxis: [
                    {
                        axisLabel: {
                            color: '#a3edb1',
                            align: 'left',
                            margin: 25
                        },
                        splitArea: {
                            show: false
                        },
                        offset: 13
                    }
                ],
                series: [
                    {
                        type: 'line',
                        showSymbol: false,
                        symbolSize: 8,
                        symbol: 'emptyCircle',
                        itemStyle: {
                            normal: {
                                color: '#ffffff',
                                borderColor: '#ffffff',
                                borderWidth: 4
                            }
                        },
                        emphasis: {
                            itemStyle: {
                                color: '#65c076'
                            }
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: 'rgba(145, 218, 159, 0.7)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(145, 218, 159, 0)'
                                    }
                                ]
                            }
                        },
                        lineStyle: {
                            normal: {
                                width: 4
                            }
                        },
                        data: [
                            Number(data.weatherJanHigh),
                            Number(data.weatherAprHigh),
                            Number(data.weatherJulHigh),
                            Number(data.weatherOctHigh)
                        ]
                    },
                    {
                        type: 'line',
                        showSymbol: false,
                        symbolSize: 8,
                        symbol: 'emptyCircle',
                        itemStyle: {
                            normal: {
                                color: '#95dfa3',
                                borderColor: '#95dfa3',
                                borderWidth: 4
                            }
                        },
                        emphasis: {
                            itemStyle: {
                                color: '#65c076'
                            }
                        },
                        areaStyle: {
                            color: '#65c076'
                        },
                        lineStyle: {
                            normal: {
                                width: 4
                            }
                        },
                        data: [
                            Number(data.weatherJanLow),
                            Number(data.weatherAprLow),
                            Number(data.weatherJulLow),
                            Number(data.weatherOctLow)
                        ]
                    }
                ]
            };
            const chartOption = {
                baseOption,
                media: [
                    {
                        query: {
                            maxWidth: 600
                        },
                        option: {
                            grid: {
                                left: 40,
                                right: 0,
                                bottom: 65,
                                top: 25
                            }
                        }
                    }
                ]
            };
            this.temperatureOptions = chartOption;
        },
        setDataCommute(data) {
            const dataCommute = [];
            const commuteObj = {
                walk: {
                    value: data.walkscore,
                    name: this.$t('md-nbr-local.walk'),
                    icon: 'icon-walk',
                    style: {
                        height:
                            (data.walkscore > 15 ? data.walkscore : 15) + '%'
                    }
                },
                bike: {
                    value: data.bikescore,
                    name: this.$t('md-nbr-local.bike'),
                    icon: 'icon-bike',
                    style: {
                        height:
                            (data.bikescore > 15 ? data.bikescore : 15) + '%'
                    }
                },
                transit: {
                    value: data.transitscore,
                    name: this.$t('md-nbr-local.publicTransit'),
                    icon: 'icon-transit',
                    style: {
                        height:
                            (data.transitscore > 15 ? data.transitscore : 15) +
                            '%'
                    }
                }
            };
            for (let key in commuteObj) {
                const item = commuteObj[key];
                if (item.value) {
                    this.maxCommute =
                        item.value > this.maxCommute
                            ? item.value
                            : this.maxCommute;
                    dataCommute.push(item);
                }
            }
            this.dataCommute = dataCommute;
        }
    },
    components: {
        nbrChart
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-nbr-local.standard {
    width: 100%;
    background-color: transparent;
    .local-box {
        width: 100%;
        height: 475px;
        position: relative;
        .local-content {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            height: 100%;
        }
        .title-wrap {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            border-bottom: solid 1px #72cc83;
        }
        .commute {
            width: calc(50% - 40px);
            height: 100%;
            color: var(--color-title);
            padding: 0;
            margin-right: 40px;
           
            .title {
                height: 60px;
                font-size: 16px;
                line-height: 60px;
                font-family: var(--font-bold);
            }
            .commute-content {
                width: 100%;
                position: relative;
                display: flex;
                justify-content: space-around;
                align-items: flex-end;
                margin-top: 86px;
                height: 209px;
                .item {
                    width: 40px;
                    position: relative;
                    border-radius: 4px;
                    max-height: 100%;
                    background-color: #6fc780;
                    color: #6fc780;
                    .value {
                        position: absolute;
                        font-size: 24px;
                        top: -46px;
                        left: 0;
                        width: 34px;
                        text-align: center;
                        color:var(--color-text);
                    }
                    .name {
                        color: #9edfab;
                        font-size: 14px;
                        line-height: 15px;
                        position: absolute;
                        bottom: -30px;
                        width: 94px;
                        text-align: center;
                        left: -27px;
                    }
                    .iconfont {
                        position: absolute;
                        bottom: 0;
                        left: 8px;
                        &::before {
                            color: #ffffff;
                            font-size: 22px;
                        }
                    }
                }
                .empty-text {
                    display: none;
                }
                &.empty {
                    .item {
                        display: none;
                    }
                    justify-content: center;
                    align-items: center;
                    .empty-text {
                        display: block;
                        font-size: 20px;
                        color: #b6e6bf;
                    }
                }
            }
        }
        .temperature-chart {
            width: 50%;
            height: 100%;
            box-shadow: none;
            background-color: transparent;
            padding: 0 0 0 40px;
            .title {
                padding-left: 0;
                height: 60px;
                line-height: 60px;
                .sub-title {
                    margin-left: 20px;
                    font-size: 14px;
                    font-family: var(--font-normal);
                }
            }
        }
        .left-background,
        .right-background {
            position: absolute;
            top: 0;
            left: 0;
            width: 50%;
            height: 100%;
            background-color: transparent;
            z-index: -1;
            &::before {
                position: absolute;
                content: '';
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background-color: #63b873;
                z-index: -1;
            }
            &::after {
                position: absolute;
                content: '';
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background-image: url('https://cdn.chime.me/image/fs01/agnentinfo/20180207/23/original_3053084083373401.png');
                background-repeat: no-repeat;
                background-size: auto 281px;
                background-position: 74px 115px;
                z-index: -1;
            }
        }
        .right-background {
            right: 0;
            left: auto;
            &::before {
                background-color: #65c076;
            }
            &::after {
                background-image: url('https://cdn.chime.me/image/fs01/agnentinfo/20180207/23/original_3053086920169828.png');
                background-size: 370px 117px;
                background-position: 79px 118px;
            }
        }
    }
    .empty-data {
        display: none;
    }
    @include media-800 {
        .local-box {
            height: auto;
            .local-content {
                height: auto;
            }
            .commute,
            .temperature-chart {
                width: 100%;
                height: 475px;
                margin: 0;
                padding-left: 0;
            }
            .left-background {
                width: 100%;
                height: 475px;
            }
            .right-background {
                width: 100%;
                top: 475px;
                height: 475px;
            }
        }
    }
    @include media-600 {
        .local-box {
            .commute {
                padding: 20px 0;
            }
            .temperature-chart {
                height: 445px;
                padding: 20px 0;
                .title {
                    height: 60px;
                    line-height: 60px;
                    padding: 0;
                }
            }
            .left-background,
            .right-background {
                &::after {
                    background-position: center 96px;
                }
            }
            .right-background {
                height: 445px;
                &::after {
                    background-position: center 118px;
                }
            }
        }
    }
}
</style>
